import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=fa83b89e"
import script from "./Snackbar.vue?vue&type=script&lang=ts"
export * from "./Snackbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa83b89e')) {
      api.createRecord('fa83b89e', component.options)
    } else {
      api.reload('fa83b89e', component.options)
    }
    module.hot.accept("./Snackbar.vue?vue&type=template&id=fa83b89e", function () {
      api.rerender('fa83b89e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/Snackbar.vue"
export default component.exports